import axios from 'axios';
import _ from 'lodash';
import * as types from '../constants/ActionTypes';

function requestArticles() {
  return {
    type: types.REQUEST_ARTICLE_LIST,
  };
}

function receiveArticlesResponse(topicList, response, selectedTopic) {
  // Get article page title and Id by using selected topic
  const articleTitle = _.get(_.find(topicList.topics, topic => String(topic.topicId) === selectedTopic), 'topicName');
  const articleId = _.get(_.find(topicList.topics, topic => String(topic.topicId) === selectedTopic), 'topicId');

  // Set article List by using L2 response data
  // No Article Limit for the Topic page
  const articleList = [];
  if (response && response.length > 0) {
    response.forEach((articleSet) => {
      articleList.push({
        id: articleSet.subTopicId,
        name: articleSet.subTopicName,
        faqList: _.isArray(articleSet.articles) && articleSet.articles,
      });
    });
  }

  return {
    type: types.RECEIVE_ARTICLE_LIST,
    payload: {
      articleList,
      articleTitle,
      articleId,
    },
  };
}

function receiveArticlesError() {
  return {
    type: types.RECEIVE_ARTICLE_LIST_ERROR,
  };
}

export default function getFaqList(topicList, topicSelected) {
  return (dispatch) => {
    dispatch(requestArticles());
    return axios.get(`/smarthelp/web-topic-tree?q=${topicSelected}`)
      .then(response => dispatch(receiveArticlesResponse(topicList, response.data.webTopicTree, topicSelected)))
      .catch(() => {
        dispatch(receiveArticlesError());
      });
  };
}



// WEBPACK FOOTER //
// ./home/actions/action-faq-list.js